import type {ListItem} from '@github-ui/markdown-editor/list-editing'
import {UnsafeHTMLBox} from '@github-ui/safe-html/UnsafeHTML'
import type {TaskItem} from '../constants/types'

import styles from './ListItem.module.css'

export type ListItemProps = {
  item: TaskItem
  position: number
}

export function ListItem({item, position}: ListItemProps) {
  const tasklistIstemTestIdBase = `tasklist-item-${position}-${item.markdownIndex}`

  return (
    <UnsafeHTMLBox
      html={item.content}
      as={'div'}
      data-testid={tasklistIstemTestIdBase}
      className={styles.ListItemContent}
    />
  )
}

try{ ListItem.displayName ||= 'ListItem' } catch {}